var _rect, _rect2, _path, _circle, _circle2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.667,
    y: 15.167,
    width: 46.667,
    height: 32.667,
    rx: 4,
    stroke: "#200041",
    strokeWidth: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 18.667,
    width: 5.833,
    height: 5.833,
    rx: 2,
    stroke: "#200041",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.28 9.272a2 2 0 011.79-1.105h13.86a2 2 0 011.79 1.105l2.947 5.895H16.333l2.948-5.895z",
    stroke: "#200041",
    strokeWidth: 1.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 31.5,
    r: 9.333,
    stroke: "#200041",
    strokeWidth: 1.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 31.5,
    r: 5.833,
    stroke: "#200041",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.562 15.167v17.646c0 2.77 2.334 3.937 2.334 6.562v8.458",
    stroke: "#200041",
    strokeWidth: 1.25
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNC42NjY3NSIgeT0iMTUuMTY2NyIgd2lkdGg9IjQ2LjY2NjciIGhlaWdodD0iMzIuNjY2NyIgcng9IjQiIHN0cm9rZT0iIzIwMDA0MSIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+CjxyZWN0IHg9IjQyIiB5PSIxOC42NjY3IiB3aWR0aD0iNS44MzMzNCIgaGVpZ2h0PSI1LjgzMzMzIiByeD0iMiIgc3Ryb2tlPSIjMjAwMDQxIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPHBhdGggZD0iTTE5LjI4MDUgOS4yNzIzMkMxOS42MTkyIDguNTk0NzUgMjAuMzExOCA4LjE2Njc1IDIxLjA2OTMgOC4xNjY3NUgzNC45MzA1QzM1LjY4ODEgOC4xNjY3NSAzNi4zODA2IDguNTk0NzUgMzYuNzE5NCA5LjI3MjMyTDM5LjY2NjYgMTUuMTY2N0gxNi4zMzMzTDE5LjI4MDUgOS4yNzIzMloiIHN0cm9rZT0iIzIwMDA0MSIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+CjxjaXJjbGUgY3g9IjI4LjAwMDEiIGN5PSIzMS41MDAxIiByPSI5LjMzMzMzIiBzdHJva2U9IiMyMDAwNDEiIHN0cm9rZS13aWR0aD0iMS4yNSIvPgo8Y2lyY2xlIGN4PSIyOC4wMDAxIiBjeT0iMzEuNTAwMSIgcj0iNS44MzMzMyIgc3Ryb2tlPSIjMjAwMDQxIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPHBhdGggZD0iTTEzLjU2MjQgMTUuMTY2N0wxMy41NjI0IDI4LjU4MzRDMTMuNTYyNCAyOC41ODM0IDEzLjU2MjQgMzAuMDQxNyAxMy41NjI0IDMyLjgxMjZDMTMuNTYyNCAzNS41ODM0IDE1Ljg5NTggMzYuNzUwMSAxNS44OTU4IDM5LjM3NTFDMTUuODk1OCA0Mi4wMDAxIDE1Ljg5NTggNDMuNjA0MiAxNS44OTU4IDQzLjYwNDJMMTUuODk1OCA0Ny44MzM0IiBzdHJva2U9IiMyMDAwNDEiIHN0cm9rZS13aWR0aD0iMS4yNSIvPgo8L3N2Zz4K";
export { SvgPhoto as ReactComponent };